import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { Component } from "react"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from 'jquery';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import { trainingMonths } from '../../../common/commonJson';
import arrowRight from "../../../../assets/img/svg/arrow_right.svg";
import arrowLeft from "../../../../assets/img/svg/arrow_left.svg";
import arrowBlackRight from "../../../../assets/img/svg/arrowblack_right.svg";
import arrowBlackLeft from "../../../../assets/img/svg/arrowblack_left.svg";

class TrainingStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            yardCurrentYear: 0,
            yardTrainingPlan: {},
            trainingMonths: [],
            ProjectId: 0,
            YardId: 0,
            isView: false,
        }
    }

    componentDidMount() {
        this.state.ProjectId = localStorage.getItem("DashId");
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.YardId = parseInt(localStorage.getItem("YardId"));
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.yardCurrentYear = new Date().getFullYear();
        this.state.trainingMonths = trainingMonths;
        this.setState({})
        this.GetTraining(this.state.ProjectId, this.state.yardCurrentYear)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TrainingPlan1 .MuiListItemText-primary").removeClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").removeClass("fw-bolder");
        $("#TrainingPlan").addClass("d-none");
        $("#TrainingPlan").removeClass("d-block");
        $("#TPL").removeClass("active-color");
        $("#TPT").removeClass("fw-bolder");
    }

    GetTraining = (yardId, year) => {
        let apiUrl = API.GET_YARDTRAININGPLAN + yardId + "/" + year + "/" + true;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        yardTrainingPlan: response.data,
                        render: true,
                    });
                    if (response.data?.TrainingPlan?.length > 0) {
                        let data = [];
                        const check = response.data?.TrainingPlan[0]
                        if (check.TrainingDate?.length > 0) {
                            check.TrainingDate?.map((t) => (
                                data.push(t.Month)
                            ))
                            this.setState({
                                trainingMonths: data
                            })
                        }
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    ActualEditPage = (i) => {
        localStorage.setItem("TrainingPlanEditId", i)
        this.props.navigate("/trainingstatus/viewactual");
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PLAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Trainingplan1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Trainingplan").removeClass("d-none");
        $("#Trainingplan").addClass("d-block");
        $("#TPL").addClass("active-color");
        $("#TPT").addClass("fw-bolder");
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    };

    navigate = (id) => {
        this.props.navigate("/yard/trainingplan/planneddate/" + id);
    }

    hasPrevious = () => {
        this.setState({
            yardCurrentYear: this.state.yardCurrentYear - 1
        }, () => {
            this.GetTraining(this.state.ProjectId, this.state.yardCurrentYear)
        })
    }

    hasNext = () => {
        this.setState({
            yardCurrentYear: this.state.yardCurrentYear + 1
        }, () => {
            this.GetTraining(this.state.ProjectId, this.state.yardCurrentYear)
        })
    }

    render() {
        const { yardTrainingPlan } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar}>
                                            <ListItemText id={"PLAN" + "1"} className='textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Training Status - {this.state.yardCurrentYear}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row">
                        <div className="px-4 pt-4">
                            <div className='col-12'>
                                <div className='row'>
                                    <div className="col-10">
                                        {this.state.isMobile ? <></> : <h6>Training Status - {this.state.yardCurrentYear}</h6>}
                                    </div>
                                    <div className="col-2 d-flex justify-content-end">
                                        <img onClick={() => this.hasPrevious()} className={` ${yardTrainingPlan?.Pagination?.HasPrevious == false ? 'img-disabled' : ''} ${'pagingArrow pr-2 mt-1 cursorPointer'}`} src={yardTrainingPlan?.Pagination?.HasPrevious == true ? arrowLeft : arrowBlackRight} /><span className='f-size-16 f-normal'>Previous</span> <span className='f-size-16 f-normal pl-2'>Next</span><img className={` ${yardTrainingPlan?.Pagination?.HasNext == false ? 'img-disabled' : ''} ${'pagingArrow pl-2 mt-1 cursorPointer'}`} onClick={() => this.hasNext()} src={yardTrainingPlan?.Pagination?.HasNext == true ? arrowBlackLeft : arrowRight} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 pt-3 py-1">
                                <div className={`${window.innerWidth < 1000 ? "" : this.state.isView === false ? "table-container1" : "table-container1"} table-responsive`}>
                                    <table id="tableview" className="table cellborder">
                                        <thead>
                                            <tr className="table-active row-head">
                                                <th rowspan="2" className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"} text-center align-middle`} style={{ minWidth: '3%', maxWidth: '3%', width: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>S.No</span></th>
                                                <th rowspan="2" className={`${window.innerWidth < 1000 ? "" : "tr-title"} text-center align-middle`} style={{ minWidth: '294px', maxWidth: '270px', width: '270px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Training Title</span></th>
                                                {this.state.trainingMonths && this.state.trainingMonths.map((i, ind) => (
                                                    <th className="text-center align-middle" style={{ width: '77px', minWidth: '77px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>{i?.split("-")[0]}</span></th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.render == true ?
                                                yardTrainingPlan && yardTrainingPlan?.TrainingPlan?.length > 0 ? yardTrainingPlan?.TrainingPlan?.map((i, ind) => (<>
                                                    <tr>
                                                        <td className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"} text-center align-middle`}><span className="spanTopBar" style={{ color: "#000000" }}>{ind + 1}</span></td>
                                                        <td className={`${window.innerWidth < 1000 ? "" : "yardtr-title pl-2"} align-middle spanTopBar`}>
                                                            <span className="spanTopBar pl-2" style={{ color: "#000000" }}>{i.TrainingTitle && i.TrainingTitle}</span>
                                                        </td>
                                                        {this.state.trainingMonths && this.state.trainingMonths.map((m) => (<>
                                                            {i?.TrainingDate?.filter((r) => r.Month == m)?.length > 0 ?
                                                                <>
                                                                    <td className="text-center align-middle tableview-set scroll-border">
                                                                        <table width="100%">
                                                                            <tbody>
                                                                                <tr>
                                                                                    {i?.TrainingDate?.filter((r) => r.Month == m)[0]?.PlannedActual?.map((r) => (<td className=''>
                                                                                        <div className='row'>
                                                                                            <div className='col-12'>
                                                                                                <span className="spanTopBar" style={{ color: "#000000" }}>{r.PlannedDate && moment(r.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span></div>
                                                                                            <div className='col-12'>
                                                                                                {(r.ActualDate == null && Date.parse(moment(r.PlannedDate).format("YYYY-MM-DD")) <= Date.parse(moment(new Date()).format("YYYY-MM-DD"))) ? <button className={`${classes.UnButton} mt-2`} onClick={() => { this.ActualEditPage(r.Id) }}>-</button> :
                                                                                                    (r.ActualDate != null) ? <button className={`${classes.linkButton} f-size-13 mt-2`} onClick={() => { this.ActualEditPage(r.Id) }}>{r.ActualDate && moment(r.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</button> :
                                                                                                        (r.PlannedDate != null) ?
                                                                                                            <button className={`${classes.whiteButtonYard} mt-2 f-size-13`} onClick={() => { this.ActualEditPage(r.Id) }}>{r.ActualDate && moment(r.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</button> : <></>}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>))}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </> : <></>}
                                                        </>))}
                                                    </tr>
                                                </>))
                                                    :
                                                    <tr>
                                                        <td className="border-left border-right text-center align-middle" colSpan={14}><h6>No data to display</h6></td>
                                                    </tr> : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

TrainingStatus.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TrainingStatus))
);
